import {macroFooterRef} from './constants';

export const hideMacroFooter = () => macroFooterRef.current?.hideFooter();
